import router from 'next/router'
import { useCallback } from 'react'
import { useStore } from '../providers/store'
import { useConfig } from '../providers/config'
import { removeTrailingSlashes } from '../utils/url'

export const useSwitchStoreUrl = () => {
	const { code } = useStore()
	const { availableStores } = useConfig()

	const switchStoreUrl = useCallback(
		(storeCode, countryCode) => {
			const baseUrl = availableStores.find((store) => store.code === storeCode)?.baseUrl

			return (
				(baseUrl ? removeTrailingSlashes(baseUrl) : '') +
				'/switch-store/?' +
				new URLSearchParams({
					...(code ? { fromStoreCode: code } : {}),
					toStoreCode: storeCode,
					countryCode,
					path: router.asPath.split('?')[0],
				}).toString()
			)
		},
		[availableStores, code]
	)

	return {
		switchStoreUrl,
	}
}
